import dayjs from "dayjs";
var utc = require("dayjs/plugin/utc");
dayjs.extend(utc);
export const toLocalTime = (utcTime) =>
  dayjs.utc(utcTime).local().format("DD-MM-YYYY HH:mm:ss");
